<template>
  <div
    v-if="display"
    class="modal-backdrop"
    tabindex="0"
    @click.self="cancel()"
  >
    <div class="cart-modal">
      <div class="cart-modal__inner">
        <div class="cart-modal__header">
          <h2 class="cart-modal__heading">
            Muokataan tuotetta
          </h2>
          <button
            class="cart-modal__close"
            @click.prevent="cancel()"
          >
            <span class="screen-reader-text">Peruuta</span>
          </button>
        </div>

        <div class="cart-modal__body">
          <div class="cart-modal__image-column">
            <span class="label label--small">Tuotekuva</span>
            <file-upload
              ref="imageupload"
              v-model="files"
              post-action="/wp-json/wp/v2/media"
              extensions="jpg,jpeg,gif,png"
              :headers="{'X-WP-Nonce': nonce}"
              :size="1024 * 1024"
              :drop="false"
              @input-file="inputFile"
              @input-filter="inputFilter"
            >
              <img
                v-if="hasImage && (product.image || customImage)"
                v-lazy="customImage || product.image.productTeaser"
                class="cart-modal__image"
                :class="{'cart-modal__image--cropped': customImage}"
                :srcset="customImage || product.image.productTeaser + ' 1x, ' + product.image.productTeaserX2 + ' 2x'"
                alt=""
              >
              <span
                v-else
                class="cart-modal__image cart-modal__image--placeholder"
              >
                <span class="cart-modal__image--placeholder__text">Ei kuvaa</span>
              </span>
            </file-upload>

            <div
              class="cart-modal__image-actions"
              :class="{'cart-modal__image-actions--no-image' : hasImage}"
            >
              <button
                class="cart-modal__image-action btn btn--secondary btn--secondary-small"
                :class="{'btn--disabled' : !hasImage}"
                :disabled="!hasImage"
                @click.prevent="removeImage()"
              >
                Poista
              </button>
              <label
                for="file"
                class="cart-modal__image-action btn btn--secondary btn--secondary-small"
              >{{ hasImage ? 'Vaihda' : 'Lisää' }}</label>
            </div>
          </div>

          <div class="cart-modal__content-column">
            <label
              class="label label--small"
              for="product_name"
            >Tuotenimi</label>
            <input
              id="product_name"
              v-model="product.custom_name"
              type="text"
            >

            <label
              class="label label--small"
              for="product_description"
            >Tuotekuvaus</label>
            <textarea
              id="product_description"
              v-model="product.description"
              class="textarea-med"
            />

            <div class="cart-modal__position-id">
              <label
                class="label label--small"
                for="product_position_id"
              >Positiotunnus</label>
              <input
                id="product_position_id"
                v-model="product.position_id"
                type="text"
              >
            </div>

            <div class="grid-wrap">
              <div class="grid-col bp1-col-one-third">
                <label
                  class="label label--small"
                  for="product_costprice"
                >Kust.hinta / kpl</label>
                <input
                  v-model="costPrice"
                  type="text"
                  name="product_costprice"
                  @keypress="forceFloat()"
                >
              </div>

              <div class="grid-col bp1-col-one-third">
                <label
                  class="label label--small"
                  for="product_price"
                >Hinta / kpl</label>
                <input
                  v-model="price"
                  type="text"
                  name="product_price"
                  @keypress="forceFloat()"
                >
              </div>

              <!--<div class="grid-col bp1-col-one-third">
                                <label class="label label--small" for="product_cargo">Rahti-%</label>
                                <div class="select">
                                    <select name="product_cargo" v-model="product.cargo">
                                        <option>XX %</option>
                                        <option>YY %</option>
                                    </select>
                                </div>
                            </div> TODO rahti-->
            </div>

            <div
              v-if="product.variations.length > 0"
              class="product-settings product-settings--modal product-settings--variations"
              :class="{ 'product-settings--open': showVariations }"
            >
              <button
                class="product-settings__toggle product-settings__toggle--small product-settings__toggle--variations"
                :class="{ 'product-settings__toggle--active product-settings__toggle--variations-active': showVariations }"
                @click.prevent="toggleVariations"
              >
                Variaatiot
              </button>

              <div
                v-if="showVariations"
                class="product-settings__content"
              >
                <ProductVariations
                  ref="productVariations"
                  :attributes="product.variation_attributes"
                  :variations="product.variations"
                  :original-selections="product.variation"
                  :hide-prices="false"
                  @change="variationsChanged"
                />
              </div>
            </div>

            <div class="cart-modal__profits">
              <div class="cart-modal__profit">
                <span class="label label--small">Kate-%</span>
                <span>{{ profitPercentage | formatPercent }} %</span>
              </div>

              <div class="cart-modal__profit">
                <span class="label label--small">Kate €</span>
                <span><price
                  :price="profitAmount"
                  :cart="true"
                /></span>
              </div>
            </div>

            <div class="cart-modal__price-container">
              <div class="cart-modal__price">
                <div class="cart-modal__price-amount-container">
                  <div class="label label--small">
                    {{ $modeoL10n.sum }}
                  </div>
                  <span class="price-amount"><price
                    :price="totalPrice"
                    :cart="true"
                  /></span>
                </div>
                <div class="cart-modal__price-details">
                  <span class="tax tax--big">{{ $modeoL10n.vat }} 0%</span>
                  <product-counter
                    :default-count="product.quantity"
                    @change="quantityChanged"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="cart-modal__actions">
            <div class="cart-modal__image-column">
              <button
                class="cart-modal__actions__delete"
                @click.prevent="remove()"
              >
                Poista tuote
              </button>
            </div>

            <div class="cart-modal__actions__buttons cart-modal__content-column">
              <button
                class="cart-modal__actions__button btn btn--secondary btn--secondary-med"
                @click.prevent="cancel()"
              >
                Peruuta
              </button>
              <button
                class="cart-modal__actions__button btn btn--med"
                @click.prevent="confirm()"
              >
                Tallenna
              </button>
            </div>
          </div>
        </div>

        <div
          v-if="saving"
          class="cart-modal__loading"
        >
          <div class="cart-modal__loading__text">
            Tallennetaan<span
              aria-hidden="true"
              class="blink"
            ><span class="dot">.</span><span class="dot">.</span><span class="dot">.</span></span>
          </div>
        </div>

        <div
          v-if="loadingImage"
          class="cart-modal__loading"
        >
          <div class="cart-modal__loading__text cart-modal__loading__text--image">
            Tallennetaan kuvaa<span
              aria-hidden="true"
              class="blink"
            ><span class="dot">.</span><span class="dot">.</span><span class="dot">.</span></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import ProductCounter from '../product/product-counter.vue';
import ProductVariations from '../product/product-variations.vue';
import axios from 'axios';
import VueUploadComponent from 'vue-upload-component';
import { EventBus } from '../../event-bus';
import _ from 'lodash';

const ESC_KEY = 27;

export default {
    components: {
        ProductCounter,
        ProductVariations,
        FileUpload: VueUploadComponent,
    },
    props: {
        display: Boolean,
        defaultProduct: {
            type: Object,
            default: function(){
                return {};
            },
        },
        nonce: {
            type: String,
            default: '',
        },
    },

    data: function () {
        return {
            product: null,
            price: 0,
            costPrice: 0,
            addOnTotal: 0,
            mandatoryAddOnTotal: 0,
            selectedAddOns: {},
            selectedMandatoryAddOns: {},
            selectedVariationID: null,
            selectedVariation: null,
            showVariations: false,
            files: [],
            customImage: false,
            customImageId: false,
            hasImage: false,
            saving: false,
            loadingImage: false,
        }
    },

    computed: {
        cartContents() {
            return this.$store.getters.getCartContents;
        },

        totalPrice() {
            return (this.parseCommaDecimalFormat(this.price) + this.parseCommaDecimalFormat(this.addOnTotal) + this.parseCommaDecimalFormat(this.mandatoryAddOnTotal)) * this.product.quantity;
        },

        totalCostPrice() {
            return (this.parseCommaDecimalFormat(this.costPrice) + this.parseCommaDecimalFormat(this.addOnTotal) + this.parseCommaDecimalFormat(this.mandatoryAddOnTotal)) * this.product.quantity;
        },

        profitPercentage() {
            let price = this.parseCommaDecimalFormat(this.totalPrice);
            let costPrice = this.parseCommaDecimalFormat(this.totalCostPrice);

            if (price < 1) {
                return 0;
            }

            return (price - costPrice) / price * 100;
        },

        profitAmount() {
            let price = this.parseCommaDecimalFormat(this.totalPrice);
            let costPrice = this.parseCommaDecimalFormat(this.totalCostPrice);

            return price - costPrice;
        },
    },

    watch: {
        defaultProduct: function (newProduct) {
            this.product = newProduct;
            if (typeof this.product.custom_name === 'undefined' || this.product.custom_name == '') {
                if (newProduct.brand_name != null) {
                    this.product.custom_name = newProduct.brand_name + " " + newProduct.name;
                } else {
                    this.product.custom_name = newProduct.name;
                }
            }
            this.selectedAddOns = newProduct.add_ons;
            this.selectedVariation = newProduct.variation;
            this.selectedVariationID = newProduct.variation_id;

            this.price = this.toCommaDecimalFormat(this.product.price);
            this.costPrice = this.toCommaDecimalFormat(this.product.cost_price);
            if (!this.costPrice) {
                this.costPrice = this.price;
            }

            this.hasImage = this.product.image ? true : false;
            this.customImageId = this.product.custom_image_id;
            this.customImage = false;
            this.saving = false;
            this.loadingImage = false;
        },
    },

    mounted: function () {
        window.addEventListener('keydown', (e) => {
            if (e.keyCode == ESC_KEY) {
                this.cancel();
            }
        });
    },

    methods: {
        remove() {
            this.$emit("remove", this.product);
        },

        confirm() {
            this.saving = true;

            this.save();
        },

        save() {
            let addOns = _.values(this.selectedAddOns).concat(_.values(this.selectedMandatoryAddOns))
                .filter(addOn => addOn && (addOn.id || addOn.product_id))
                .map(addOn => {
                    if (addOn.variation_id) {
                        return {
                            variation_id: addOn.variation_id,
                            product_id: addOn.product_id,
                        }
                    } else {
                        return {
                            product_id: addOn.id,
                        }
                    }
                });

            let request = {
                "cart_item_key": this.product.key,
                "add_ons": addOns,
                "quantity": this.product.quantity,
                "price": this.parseCommaDecimalFormat(this.price),
                "cost_price": this.parseCommaDecimalFormat(this.costPrice),
                "position_id": this.product.position_id,
                "description": this.product.description,
                "custom_name": this.product.custom_name,
                'variation_id': this.selectedVariationID,
                "variation": this.selectedVariation,
                "custom_image": this.hasImage ? this.customImageId : false,
                "no_image": !this.hasImage,
                "create_new_item": true,
            };

            let config = {
                headers: {
                    'X-WP-Nonce': this.nonce,
                },
            }

            axios.post('/wp-json/modeo/v2/cart/update_cart_item', request, config)
            .then(response => {

                let totals = {
                    subtotal: response.data.subtotal,
                    subtotalTax: response.data.subtotal_tax,
                    total: response.data.total,
                    discount: response.data.discount_total,
                    discountTax: response.data.discount_tax,
                    count: response.data.cart_product_count,
                };

                this.$store.commit('setTotals', totals);

                let data = {
                    'oldKey': this.product.key,
                    'cartItem': response.data.cart_item,
                };

                this.$emit("confirm", data);

            })
            .catch(() => {
              this.$emit("cancel");
              EventBus.$emit("notify", {
                  message: 'Tuotteen muokkaus epäonnistui.',
                  notificationType: "single-message",
              });
            });
        },

        quantityChanged(quantity) {
            this.product.quantity = quantity;
        },

        addOnsChanged(data) {
            this.selectedAddOns = data.addOns;
            this.addOnTotal = data.totals.total;
        },

        variationsChanged(data) {
            this.selectedVariationID = data.selectedVariation.variation_id;
            this.selectedVariation = data.selections;
        },

        cancel() {
            this.$emit("cancel");
        },

        toggleVariations() {
            this.showVariations = !this.showVariations;
        },

        inputFile: function (newFile) {
            this.product.image = false;

            // error
            if (newFile && newFile.error) {
              this.loadingImage = false;
              EventBus.$emit("notify", {
                  message: 'Kuvan lataus epäonnistui.',
                  notificationType: "single-message",
              });
            }

            // Get new image id and save when upload is ready
            if (newFile && !newFile.active && newFile.xhr && newFile.xhr.status == 201) {
                let response = JSON.parse(newFile.xhr.response);
                this.customImageId = response.id;
                this.loadingImage = false;
                this.$refs.imageupload.clear();
            }
        },

        inputFilter: function (newFile, oldFile, prevent) {
            if (newFile) {
                // Filter non-image file
                if (!/\.(jpeg|jpg|gif|png)$/i.test(newFile.name)) {
                    return prevent();
                }

                // Create a blob
                newFile.blob = '';
                let URL = window.URL || window.webkitURL;
                if (URL && URL.createObjectURL) {
                    newFile.blob = URL.createObjectURL(newFile.file);
                    this.customImage = newFile.blob;
                    this.hasImage = true;
                    this.$refs.imageupload.active = true;
                    this.loadingImage = true;
                }
            }
        },

        removeImage() {
            this.hasImage = false;
            this.customImage = false;
            this.product.image = false;
        },

    },
}
</script>
